/* =========================================================================
   SAMSARA SCROLL LOCK — iOS-safe, fără modificări în consumatori.

   Problema inițială (2026-08-24, mobil):
   1. `body { overflow: hidden }` NU blochează scroll-ul pe iOS Safari. Cu
      coșul deschis, degetul derula pagina din spate.
   2. Schimbarea de overflow declanșa un reflow, iar containerele cu
      `scroll-snap-type: x mandatory` (caruselul de origini) se re-snap-uiau
      la primul slide — „mă dă de la începutul caruselului".

   CAPCANA care a urmat (aceeași zi): nu poți citi `window.scrollY` DUPĂ ce
   clasa a fost pusă. Citirea forțează un recalcul de layout, care aplică
   `position: fixed`, colapsează documentul și întoarce 0. Poziția se pierdea
   și pagina sărea sus. De aceea ținem poziția actualizată CONTINUU, iar
   offset-ul îl trimitem în CSS printr-o variabilă — se aplică atomic cu clasa,
   fără citire întârziată și fără o clipire la top.
   ========================================================================= */

(function () {
  'use strict';

  var LOCK_CLASS = 'is-scroll-locked';
  var TRACK_SELECTOR = '[data-origins-track], [data-carousel-track]';
  var root = document.documentElement;

  var active = false;
  var lastY = 0;
  var savedTracks = [];
  var ticking = false;

  function currentY() {
    return window.scrollY || window.pageYOffset || 0;
  }

  function publishY(y) {
    lastY = y;
    root.style.setProperty('--scroll-y', y + 'px');
  }

  // Throttle pe rAF: o singură scriere pe cadru, doar când valoarea s-a schimbat.
  // Tema a mai avut probleme de jitter la scroll, deci nu scriem pe fiecare eveniment.
  function onScroll() {
    if (active || ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = currentY();
      if (y !== lastY) publishY(y);
    });
  }

  function snapshotTracks() {
    savedTracks = [];
    var nodes = document.querySelectorAll(TRACK_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].scrollLeft > 0) {
        savedTracks.push({ el: nodes[i], left: nodes[i].scrollLeft });
      }
    }
  }

  function restoreTracks() {
    var pending = savedTracks;
    savedTracks = [];
    if (!pending.length) return;

    requestAnimationFrame(function () {
      for (var i = 0; i < pending.length; i++) {
        var t = pending[i];
        if (!t.el.isConnected || t.el.scrollLeft === t.left) continue;
        var prev = t.el.style.scrollBehavior;
        t.el.style.scrollBehavior = 'auto'; // restaurare instantanee, fără animație de retur
        t.el.scrollLeft = t.left;
        t.el.style.scrollBehavior = prev;
      }
    });
  }

  function applyLock() {
    active = true;
    // NU citim window.scrollY aici — vezi capcana din antet. Folosim ultima
    // valoare publicată, care e deja în CSS ca `--scroll-y`.
    snapshotTracks();
  }

  function releaseLock() {
    active = false;
    var y = lastY;
    window.scrollTo(0, y);
    // Poziția reală poate diferi (pagină mai scurtă după re-render); resincronizăm.
    publishY(currentY());
    restoreTracks();
  }

  function sync() {
    var locked = document.body.classList.contains(LOCK_CLASS);
    if (locked && !active) applyLock();
    else if (!locked && active) releaseLock();
  }

  if (!document.body) return;

  publishY(currentY());
  window.addEventListener('scroll', onScroll, { passive: true });

  // Plasă de siguranță: dacă un modal se deschide fără ca utilizatorul să fi
  // derulat de la încărcare, `--scroll-y` e deja corect din publishY de mai sus.
  // La tap, o resincronizăm oricum înainte ca vreun handler să apuce să blocheze.
  document.addEventListener(
    'pointerdown',
    function () {
      if (!active) publishY(currentY());
    },
    { capture: true, passive: true }
  );

  new MutationObserver(sync).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });

  sync();
})();
